import React from 'react';
import TrophyIcon from '../../../icons/Trophy';
import * as Styled from './styles';

const Trophy = () => (
    <Styled.TrophyIconContainer>
        <TrophyIcon />
    </Styled.TrophyIconContainer>
);

export default Trophy;
